import { SVGProps } from 'react';

import { iconByName } from './constants';
import { IconName } from './types';

type IconProps = SVGProps<SVGSVGElement> & {
  name: IconName;
};

export const Icon = ({ name, ...props }: IconProps) => {
  const SvgIcon = iconByName[name];

  if (!SvgIcon) return null;

  return <SvgIcon {...props} />;
};
